/**
 * 考试管理
 */
const examinationRouter = {
  path: '/examination',
  component: () => import('@/views/layout'),
  redirect: '/examination/EIM/list',
  meta: {
    title: '考试管理',
    icon: require('@/assets/slider/exam.png')
  },
  alwaysShow: true,
  children: [
    {
      path: 'EIM/list',
      name: 'EIMList',
      component: () => import('@/views/examination/EIM/list'),
      meta: {
        title: '考试信息管理',
        keepAlive: false
      }
    },
    {
      path: 'TQB/list',
      name: 'TQBList',
      component: () => import('@/views/examination/TQB/list'),
      meta: {
        title: '试题库',
        keepAlive: false
      }
    },
    {
      path: 'TPL/list',
      name: 'TPLList',
      component: () => import('@/views/examination/TPL/list'),
      meta: {
        title: '试卷库',
        keepAlive: false
      }
    },
    {
      path: 'AC/list',
      name: 'ACList',
      component: () => import('@/views/examination/AC/list'),
      meta: {
        title: '答题卡',
        keepAlive: false
      }
    },
    {
      path: 'SA/list',
      name: 'SAChoice',
      component: () => import('@/views/examination/SA/choice'),
      meta: {
        title: '统计分析',
        keepAlive: false
      }
    }
  ]
}

const examinationDescRouter = {
  path: '/examination',
  component: () => import('@/views/layout'),
  redirect: '/examination/EIM/list',
  hidden: true,
  meta: {
    title: 'desc'
  },
  children: [
    {
      path: 'SA/test',
      name: 'SATest',
      component: () => import('@/views/examination/SA/test'),
      meta: {
        title: '统计分析1',
        keepAlive: false
      },
      hidden: true
    },
    {
      path: 'SA/examinee',
      name: 'SAExaminee',
      component: () => import('@/views/examination/SA/examinee'),
      meta: {
        title: '统计分析2',
        keepAlive: false
      },
      hidden: true
    },

    {
      path: 'EIM/establish',
      name: 'EIMeEstablish',
      component: () => import('@/views/examination/EIM/establish'),
      meta: {
        title: '创建考试',
        keepAlive: false
      },
      hidden: true
    },
    {
      path: 'EIM/excel/:id',
      name: 'RiskSurface',
      component: () => import('@/views/examination/EIM/riskSurface'),
      meta: {
        title: '风险评估导出',
        keepAlive: false
      },
      hidden: true
    },
    {
      path: 'EIM/edit/:id',
      name: 'EIMEdit',
      component: () => import('@/views/examination/EIM/edit'),
      meta: {
        title: '编辑考试',
        keepAlive: false
      },
      hidden: true
    },

    {
      path: 'TQB/establish',
      name: 'TQBEstablish',
      component: () => import('@/views/examination/TQB/establish'),
      meta: {
        title: '创建考试',
        keepAlive: false
      },
      hidden: true
    },
    {
      path: 'TQB/edit/:id',
      name: 'TQBEdit',
      component: () => import('@/views/examination/TQB/edit'),
      meta: {
        title: '编辑考试',
        keepAlive: false
      },
      hidden: true
    },
    {
      path: 'TPL/edit/:id',
      name: 'TPLEdit',
      component: () => import('@/views/examination/TPL/edit'),
      meta: {
        title: '编辑考试',
        keepAlive: false
      },
      hidden: true
    },
    {
      path: 'AC/ACdetail/:id',
      name: 'ACACdetail',
      component: () => import('@/views/examination/AC/detail'),
      meta: {
        title: '详情',
        keepAlive: false
      },
      hidden: true
    },
    {
      path: 'SA/test/:id',
      name: 'SAtest',
      component: () => import('@/views/examination/SA/test'),
      meta: {
        title: '详情',
        keepAlive: false
      },
      hidden: true
    },
    {
      path: 'SA/examinee/:id',
      name: 'SAexaminee',
      component: () => import('@/views/examination/SA/examinee'),
      meta: {
        title: '详情',
        keepAlive: false
      },
      hidden: true
    }
  ]
}

export { examinationRouter, examinationDescRouter }
